import { render, staticRenderFns } from "./simple-image-uploader.vue?vue&type=template&id=8bfd1a38&"
import script from "./simple-image-uploader.vue?vue&type=script&lang=js&"
export * from "./simple-image-uploader.vue?vue&type=script&lang=js&"
import style0 from "./simple-image-uploader.vue?vue&type=style&index=0&id=8bfd1a38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports